module.exports = {"532627101":"莲城镇","532627102":"八宝镇","532627103":"南屏镇","532627104":"珠街镇","532627105":"那洒镇","532627106":"珠琳镇","532627107":"坝美镇","532627201":"董堡乡","532627202":"旧莫乡","532627203":"杨柳井乡","532627204":"板蚌乡","532627205":"曙光乡","532627206":"黑支果乡","532627207":"篆角乡","532627208":"五珠乡","532627209":"者兔乡","532627210":"者太乡","532627211":"底圩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532627.json
// module id = 2779
// module chunks = 0